/* eslint-disable no-unused-vars */
import { SOURCE_KEY, LEARNING_CENTER_SOURCE_PREFIX, SOURCE_PREFIX, SOURCE_ID_DESTINATIONS } from './Constants';
import { mergeSearchParams } from '../../../searchParams';

export const containsAnySubstring =(input, substrings) => substrings.some(substring => input.includes(substring));

export const getFirstPathSection = (href) => 
{
    // Remove the protocol and domain part
    const path = href.replace(/^https?:\/\/[^\/]+/, '');
    // Split the path by '/'
    const parts = path.split('/');
    // Find the first non-empty part
    const firstSection = parts.find(part => part.length > 0);
    // Return 'home' if no first section is found
    return firstSection || 'home';
}

export const replaceLearningCenterSourceIdHash = ({ url, articleId = '' }) => 
{
    const [_hashtag, ...sourceId] = url?.hash?.split('-') || []; // #key-value -> [#key, value] -> [_, value]
    const resolvedSuffix = [articleId, ...sourceId] // order
        .filter((value) => value) // remove any falsey values
        .map((value) => `-${value}`) // prefix "-" hyphen
        .join(''); // convert to string
    let usedSourcePrefix = LEARNING_CENTER_SOURCE_PREFIX
    if(window?.location?.href)
    {
        usedSourcePrefix = `${SOURCE_PREFIX}${getFirstPathSection(window.location.href)}`
    }

    return `${usedSourcePrefix}${resolvedSuffix}`; // qlwebsite_learn-ARTICLEID-CMSVARIABLE
};

export const replaceLearningCenterSourceId = ({
    href,
    location,
    sourceid,
    articleId = '',
}) => 
{
    let replacedUrl = '';
    try 
    {
        const url = new URL(href);
        if (sourceid) 
        {
            url.searchParams.set(SOURCE_KEY, sourceid);
        }
        else if (containsAnySubstring(href,SOURCE_ID_DESTINATIONS))
        {
            url.searchParams.set(
                SOURCE_KEY,
                replaceLearningCenterSourceIdHash({ url, articleId })
            );
        }
        const mergedSearchParams = mergeSearchParams(
            location?.search,
            url.searchParams
        );
        url.search = mergedSearchParams.toString();
        url.hash = '';
        url.pathname = url.pathname === '//' ? '/' : url.pathname;
        replacedUrl = url.href;
    }
    catch (error) 
    {
        replacedUrl = href;
    }

    return replacedUrl;
};
